/* eslint-disable no-unneeded-ternary */
import { Home, Circle, User, Tag, ShoppingCart, Search, LogOut, File, Upload, Briefcase } from 'react-feather'
import icons from '../../assets/images/icons/icons'
import { store } from '../../redux/store'

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}

export default [
  {
    id: 'home',
    title: <h1 className='menuItens'>Pagina Inicial</h1>,
    icon: <Home className='menuIcon' size={20} />,
    navLink: '/home'
  },
  {
    id: 'user',
    title: <h1 className='menuItens'>Perfil</h1>,
    icon: <User className='menuIcon' size={20} />,
    navLink: "/perfil"
  },
  {
    id: 'XML',
    title: <h1 className='menuItens'>Documentos fiscais</h1>,
    icon: <File className='menuIcon' size={20} />,
    navLink: "/documentos-fiscais",
    disabled: initialUser() !== null && initialUser().user.acesso_captura === true ? false : true
  },
  {
    id: 'Calculo',
    title: <h1 className='menuItens'>Calculadora</h1>,
    icon: icons[0].icon,
    children: [
      {
        id: 'ICMS-ST',
        title: 'ICMS-ST',
        icon: <Circle size={12} />,
        navLink: '/calculadora/icmsst',
        disabled: initialUser() !== null && initialUser().user.acesso_st === true ? false : true
      },
      {
        id: 'DIFAL',
        title: 'DIFAL',
        icon: <Circle size={12} />,
        navLink: '/calculadora/difal',
        disabled: initialUser() !== null && initialUser().user.acesso_st === true ? false : true
      }
    ]
  },
  {
    id: 'guias',
    title: <h1 className='menuItens'>Guias de pagamentos</h1>,
    icon: <Tag className='menuIcon' size={20} />,
    navLink: '/guias',
    disabled: initialUser() !== null && initialUser().user.acesso_guia === true ? false : true
  },
  {
    id:"Simulador",
    title:<h1 className='menuItens'>Simulador</h1>,
    icon:<ShoppingCart className='menuIcon' size={20}/>,
    navLink:"/simulador",
    disabled: initialUser() !== null && initialUser().user.acesso_simulador === true ? false : true
  },
  {
    id: 'Consultas',
    title: <h1 className='menuItens'>Consultas</h1>,
    icon: <Search className='menuIcon' size={20} />,
    navLink: "/consultas",
    disabled: initialUser() !== null && (initialUser().user.acesso_consulta === true ? false : true && initialUser().user.plano.num_consulta_mva === 99999)
  }
]
